import {NumberUtil} from "base/utilities";
import {SectionCard, SectionField} from "base/component/presentational";

import Grid from "@mui/material/Grid";

const SubaglomeracionInventarioBombeosSection = ({subaglomeracion}) => {
    return (
        <SectionCard title="Bombeos">
            <Grid container>
                <Grid item xs={12} lg={6}>
                    <SectionField
                        label="Totais:"
                        value={NumberUtil.formatInteger(subaglomeracion.stats.bombeos)}
                        tooltipText="Bombeos totais da rede"
                    />
                </Grid>
            </Grid>
        </SectionCard>
    );
};

export default SubaglomeracionInventarioBombeosSection;
